export enum OnboardingStatus {
  NotFound = 'NotFound',
  Onboarding = 'Onboarding',
  Registered = 'Registered',
  Uninstalled = 'Uninstalled'
}
